// Logica pura da tela da Azul (sem Vue), separada para poder ser testada sem navegador.

// Etapas do pipeline da Azul (mesmo componente PipelineSteps da CVC).
export const AZUL_STEPS = [
  { label: "E-mail da Azul", icon: "mdi-email-search-outline" },
  { label: "Download do anexo", icon: "mdi-paperclip" },
  { label: "Descompactação", icon: "mdi-folder-zip-outline" },
  { label: "Validação da planilha", icon: "mdi-table-check" },
  { label: "Importação no Phoenix", icon: "mdi-tray-arrow-down" },
  { label: "Gravação no Drive", icon: "mdi-google-drive" },
  { label: "Fila de importação", icon: "mdi-timer-sand" },
  { label: "Pendências", icon: "mdi-clipboard-alert-outline" },
];

// Etapas da execucao SO DE RESPOSTAS (painel "Respostas da Azul").
export const AZUL_STEPS_RESPOSTAS = [
  { label: "Verificação inicial", icon: "mdi-shield-check-outline" },
  { label: "Leitura dos e-mails", icon: "mdi-email-search-outline" },
  { label: "Correção no Phoenix", icon: "mdi-check-decagram-outline" },
];
const ETAPA_RESPOSTAS_PARA_INDICE = { start: 0, preflight: 0, respostas: 1, resposta_email: 2 };

// Evento do agente (etapa_atual da execucao) -> indice em AZUL_STEPS.
const ETAPA_PARA_INDICE = {
  start: 0,
  preflight: 0,
  mail_search: 0,
  mail_found: 0,
  mail_stale: 0,
  mail_not_found: 0,
  attachment_download: 1,
  zip_extract: 2,
  sheet_validate: 3,
  sheet_rename: 3,
  dry_run: 4,
  file_skipped: 4,
  phoenix_login: 4,
  phoenix_import_submit: 4,
  drive_upload: 5,
  queue_wait: 6,
  pendencies: 7,
  pendency_item: 7,
  phoenix_snapshot: 4,
  reconciliacao: 7,
};

/** Indice da etapa em andamento (para o PipelineSteps), ou null. */
export function stepIndexFromEtapa(etapa, tipo = "completa") {
  const mapa = tipo === "respostas" ? ETAPA_RESPOSTAS_PARA_INDICE : ETAPA_PARA_INDICE;
  return Object.prototype.hasOwnProperty.call(mapa, etapa) ? mapa[etapa] : null;
}

// Nome legivel da etapa onde um erro aconteceu.
const ETAPA_LABEL = {
  start: "início",
  preflight: "verificação inicial",
  lock: "execução já em andamento",
  mail_search: "busca do e-mail",
  mail_found: "busca do e-mail",
  attachment_download: "download do anexo",
  zip_extract: "descompactação",
  sheet_validate: "validação da planilha",
  sheet_rename: "renomeação",
  phoenix_login: "login no Phoenix",
  phoenix_import_submit: "importação no Phoenix",
  drive_upload: "gravação no Drive",
  queue_wait: "fila de importação do Phoenix",
  pendencies: "leitura das pendências",
  pendency_item: "leitura das pendências",
};
export const etapaLabel = (step) => ETAPA_LABEL[step] || step || "execução";

/** "2026-10-06 15:31:13" -> "15:31" */
export function hora(s) {
  const m = /(\d{2}):(\d{2})/.exec(String(s || "").split(" ")[1] || "");
  return m ? `${m[1]}:${m[2]}` : "";
}

/** "2026-10-06" -> "06/10/2026" */
export function isoParaBr(iso) {
  const p = String(iso || "").split("-");
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : "";
}

/** Timeline do banco ({logged_at,text}) -> formato do LogTimeline da CVC ({time,text}). */
export function logsParaTimeline(logs) {
  return (logs || []).map((l) => ({ time: hora(l.logged_at), text: l.text }));
}

/** Chip de status do painel: o que mostrar (null = nada, como na CVC quando esta "Disponivel"). */
export function statusDoPainel(ultima, emAndamento, naFila = false) {
  if (emAndamento) return "andamento";
  // Pedido feito que ainda espera a vez (o poller roda no maximo 2 por vez): "Na fila", nao "Em execucao".
  if (naFila) return "fila";
  if (!ultima) return "sucesso";
  if (
    ultima.status === "erro" ||
    ultima.status === "sem_email" ||
    ultima.status === "aguardando_decisao"
  ) {
    return ultima.status;
  }
  return "sucesso";
}

/** Data de hoje (AAAA-MM-DD) no horario de Brasilia, como o backend grava. */
export function hojeBRT(agora = new Date()) {
  return new Date(agora.getTime() - 3 * 3600 * 1000).toISOString().slice(0, 10);
}

/** "06/10/2026" (date de uma execucao) e' de hoje? */
export function ehDeHoje(dateBr, agora = new Date()) {
  return isoParaBr(hojeBRT(agora)) === dateBr;
}
